import React, { Fragment } from "react";
import { observer } from "mobx-react";
import { isFn } from "@al/aku-lc-helpers";
import { useForm } from "../hooks";
export var FormConsumer = observer(function (props) {
    var children = isFn(props.children) ? props.children(useForm()) : null;
    return React.createElement(Fragment, null, children);
});
FormConsumer.displayName = "FormProvider";
